import { Component, inject } from '@angular/core';
import {TranslationService} from "../../core/services/translation.service";
import {CssPropertiesEnum} from "../../core/models/css-properties.enum";
import {VHostService} from "../../core/services/v-host.service";
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";
import {CssPropertyPipe} from "../../core/pipes/css-property.pipe";
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css'],
  imports: [
    MatCard,
    MatCardHeader,
    MatCardContent,
    MatCardTitle,
    ApplyIfNotEmptyDirective
  ],
  standalone: true
})
export class CustomerComponent {
  translationService = inject(TranslationService);
  vHostService = inject(VHostService);
  navigationService = inject(NavigationService);

  CssPropertiesEnum = CssPropertiesEnum;
  cssPropertyPipe = new CssPropertyPipe();

  navigateToInvoices() {
    const pageSize = document.getElementById('customer-page')?.offsetWidth < 1280 ? 1 : 2
    this.navigationService.navigateTo(NavigationCommand.CUSTOMERINVOICE, [pageSize.toString()])
  }

  hasCustomResponsivClasses() {
    return !!this.getCustomResponsivClasses();
  }

  getCustomResponsivClasses() {
    const t = this.cssPropertyPipe.transform;

    const classes = [
      'col-' + t(CssPropertiesEnum.customerFxFlex, this.vHostService),
      'col-sm-' + t(CssPropertiesEnum.customerFxFlexSM, this.vHostService),
      'col-md-' + t(CssPropertiesEnum.customerFxFlexMD, this.vHostService),
      'col-lg-' + t(CssPropertiesEnum.customerFxFlexLG, this.vHostService),
      'col-xl-' + t(CssPropertiesEnum.customerFxFlexXL, this.vHostService),
      'col-xxl-' + t(CssPropertiesEnum.customerFxFlexXXL, this.vHostService)
    ].join(' ');

    return /\d/.test(classes) ? classes : '';
  }
}
